import {ACTION_TYPE} from "utils/constants";

const CAR_UUID = "d9391b15-9552-489f-9263-38431f0669cc"; // 에셋 삭제는 고려되어 있지 않음

let newAssetCreated = false;
let isPublished = false;

export function _onInit() {
  this.ctx.addEventListener(ACTION_TYPE.OBJECT_ADDED, e => {
    if (this.missionIndex === 0 || this.missionIndex === 1 || this.missionIndex === 3) {
      newAssetCreated = true;
    }
  });
  this.ctx.addEventListener(ACTION_TYPE.CHANGE_PROGRESS, e => {
    if (this.missionIndex === 4 && e.detail.object === 100) {
      isPublished = true;
    }
  });
}

export function _onPlayStart() {
  let stepSuccess = false;
  const {script} = this.ctx.sceneEdit.userData;

  switch (this.missionIndex) {
    case 0:
    case 1:
    case 3:
      if (newAssetCreated) {
        stepSuccess = true;
      }
      break;
    case 2:
      if (script?.includes("moveX(20)") || script?.includes("moveY(20)") || script?.includes("moveZ(20)")) {
        stepSuccess = true;
      }
      break;
    case 4:
      if (!isPublished) break;
      // const regex = /this.getSprite\("d9391b15-9552-489f-9263-38431f0669cc"\).turn\("y", \d{3,}/g;
      const regex = /turn\("y", [0-9]{1,}/g;
      const matched = script.match(regex);
      if (!matched) break;
      for (const str of matched) {
        const splitted = str.split('turn("y", ');
        const value = Number(splitted[1]);
        if (value >= 360) {
          stepSuccess = true;
          break;
        }
      }
      break;
    default:
      break;
  }
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent(stepSuccess ? ACTION_TYPE.TUTORIAL_MISSION_SUCCESS : ACTION_TYPE.TUTORIAL_MISSION_FAIL));
  }, 5000);
  newAssetCreated = false;
}

export function _onPlayEnd() {}

export function _onPlaying() {}

export function _onReset() {
  newAssetCreated = false;
  isPublished = false;
}
